module.exports = __webpack_public_path__ + "static/media/circle.322433fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/claims/details/circle.png
// module id = 2097
// module chunks = 147